var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F1F2F2",
    points: "245,219.933 167,176.733 167,6.34 245,49.541 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D1D3D4",
    points: "245,219.933 119,184.476 119,14.084 245,49.541 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "245,219.933 75,212.191 75,41.798 245,49.541 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6D6E71",
    points: "245,219.933 56,261.914 56,91.52 245,49.541 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6D6E71",
    points: "75,294.173 75,248 110.984,248 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.528,102.031c7.47-3.166,19.461-6.591,31.256-8.804c17.103-3.209,28.111-2.333,36.17,2.817 c6.881,3.805,11.206,10.833,11.206,21.22c0,12.935-8.648,25.728-22.409,33.209v0.588c12.581,0.58,27.324,8.2,27.324,27.799 c0,11.367-4.521,21.035-11.401,28.598c-9.042,10.123-23.982,16.846-45.607,20.902c-11.794,2.213-20.838,3.126-26.538,3.412 L109.528,102.031z M126.631,152.913L142.162,150c17.889-3.356,28.503-14.95,28.503-27.689c0-15.287-11.598-19.383-28.897-16.137 c-7.863,1.475-12.385,2.911-15.137,4.016L126.631,152.913z M126.631,216.021c3.539-0.076,8.257-0.766,14.351-1.909 c17.692-3.319,34.008-12.847,34.008-32.054c0-17.834-15.529-22.564-34.205-19.061l-14.154,2.655L126.631,216.021z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLogo);
export default __webpack_public_path__ + "static/media/grey_logo.e012e7cc1a05d30c203c85115990d498.svg";
export { ForwardRef as ReactComponent };